<div class="modal-header blue">
  <h4 class="modal-title">
    {{ isEditMode ? 'View/Modify Insurance Setup' : 'Add Insurance Setup' }}
  </h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form
  [formGroup]="insuranceForm"
  class="modal-body insurance-modal"
  [class.loading]="isLoading"
>
  <div class="pr-3">
    <div class="form-row md mb-3">
      <div class="col-6">
        <div class="input-label required">SC Insurance id</div>
        <input
          type="text"
          formControlName="id"
          placeholder="Enter SC Insurance id"
          class="input"
        />
      </div>
      <div class="col-6">
        <div class="input-label required">Payer id</div>
        <input
          type="text"
          formControlName="neicId"
          placeholder="Enter Contact Name"
          class="input"
        />
      </div>
    </div>
    <div class="form-row md mb-3">
      <div class="col">
        <div class="input-label">claim filing indicator</div>

        <claim-filing-indicators-select formControlName="claimFilingIndicator">
        </claim-filing-indicators-select>
      </div>
    </div>
    <div class="form-row md mb-3">
      <div class="col-6">
        <div class="input-label required">Name</div>
        <input
          type="text"
          formControlName="name"
          placeholder="Enter Name"
          class="input"
          [class.is-invalid]="
            insuranceForm.get('name')?.invalid &&
            insuranceForm.get('name')?.touched
          "
        />

        <div
          class="invalid-feedback d-block text-left"
          *ngIf="
            insuranceForm.get('name')?.invalid &&
            insuranceForm.get('name')?.touched
          "
        >
          <span *ngIf="insuranceForm.get('name')?.errors?.notUnique"
            >Name for insurance shoud be unique</span
          >
        </div>
      </div>
      <div class="col-6">
        <div class="input-label">Contact name</div>
        <input
          type="text"
          formControlName="contactName"
          placeholder="Enter Contact Name"
          class="input"
        />
      </div>
    </div>
    <div class="form-row md mb-3">
      <div class="col-6">
        <div class="input-label">Phone</div>
        <input
          type="text"
          formControlName="contactPhone"
          placeholder="Enter Phone"
          class="input"
        />
      </div>
      <div class="col-6">
        <div class="input-label">Fax</div>
        <input
          type="text"
          formControlName="contactFax"
          placeholder="Enter FAX"
          class="input"
        />
      </div>
    </div>
    <div class="form-row md mb-3">
      <div class="col-4">
        <div class="input-label required">state</div>

        <states formControlName="payerState"></states>
      </div>
      <div class="col-4">
        <div class="input-label">claim status id</div>
        <input
          type="text"
          formControlName="claimStatusId"
          placeholder="Enter Claim Status Id"
          class="input"
        />
      </div>

      <div class="col-4">
        <div class="input-label">Eligibility id</div>
        <input
          type="text"
          formControlName="realtimeId"
          placeholder="Enter Eligibility id"
          class="input"
        />
      </div>
    </div>
    <div class="form-row md mb-3">
      <div class="col">
        <div class="input-label mb-2">Eligibility type</div>
        <div class="d-flex">
          <label class="input-wrap radio mr-3">
            <input type="radio" formControlName="eligibilityType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mr-3">
            <input type="radio" formControlName="eligibilityType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio">
            <input type="radio" formControlName="eligibilityType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>
      </div>
    </div>
    <div class="form-row md mb-3">
      <div class="col">
        <div class="input-label mb-2">Claim Status Type</div>
        <div class="d-flex">
          <label class="input-wrap radio mr-3">
            <input type="radio" formControlName="claimStatusType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mr-3">
            <input type="radio" formControlName="claimStatusType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio">
            <input type="radio" formControlName="claimStatusType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>
      </div>
    </div>
    <div class="form-row md">
      <div class="col">
        <div class="input-label">Notes</div>
        <div class="input-wrap">
          <textarea rows="4" formControlName="notes"> </textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="pr-3">
    <div class="d-flex mb-3">
      <checkbox
        class="mr-3"
        formControlName="recordStatus"
        checkedValue="A"
        uncheckedValue="D"
      >
        Active
      </checkbox>

      <checkbox formControlName="legacy" checkedValue="Y" uncheckedValue="N">
        Legacy
      </checkbox>
    </div>

    <div class="mb-3">
      <label class="mb-2">Transactions</label>

      <div class="checkbox-group vertical">
        <!-- ERA  -->

        <!-- processorId -->
        <checkbox
          formControlName="transactionProfessionalClaims"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Professional Claims
        </checkbox>

        <!-- ubProcessorId -->
        <checkbox
          formControlName="transactionInstitutionalClaims"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Institutional Claims
        </checkbox>

        <!-- publishEra -->
        <checkbox
          formControlName="transactionERA"
          checkedValue="Y"
          uncheckedValue="N"
        >
          ERA
        </checkbox>

        <!-- realTimeId -->
        <checkbox
          formControlName="transactionEligibility"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Eligibility
        </checkbox>

        <!-- claimStatusId -->
        <checkbox
          formControlName="transactionClaimStatus"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Claim Status
        </checkbox>

        <!-- attachmentsProcessorId -->
        <checkbox
          formControlName="transactionAttachments"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Attachments
        </checkbox>
      </div>
    </div>

    <div class="mb-3">
      <label class="mb-2">Publish to</label>

      <div class="checkbox-group vertical">
        <checkbox
          formControlName="publishProfessional"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Professional
        </checkbox>

        <checkbox
          formControlName="publishInstitutional"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Institutional
        </checkbox>

        <checkbox
          formControlName="publishEra"
          checkedValue="Y"
          uncheckedValue="N"
        >
          ERA
        </checkbox>

        <!-- claimStatusId -->
        <checkbox
          formControlName="publishClaimStatus"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Claim Status
        </checkbox>

        <!-- realTimeId -->
        <checkbox
          formControlName="publishEligibility"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Eligibility
        </checkbox>

        <!-- attachmentsProcessorId -->
        <checkbox
          formControlName="publishAttachment"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Attachment
        </checkbox>
      </div>
    </div>

    <div>
      <div class="input-label mb-2">Additional Transactions</div>

      <div class="flex-container">
        <checkbox
          class="d-inline-block mb-2"
          formControlName="secondaryClaims"
          checkedValue="S"
          uncheckedValue="N"
        >
          Secondary Claims
        </checkbox>

        <checkbox
          class="d-inline-block"
          formControlName="batchClaimStatus"
          checkedValue="Y"
          uncheckedValue="N"
        >
          Batch Claim Status
        </checkbox>
      </div>
    </div>
  </div>
</form>

<div class="modal-footer">
  <button
    class="button ml-auto"
    [disabled]="insuranceForm.invalid"
    (click)="save()"
  >
    {{ isEditMode ? 'Save' : 'Add Insurance' }}
  </button>
</div>
